export default "__VITE_ASSET__dFQ46cSG__"